import { computed } from 'vue';

import router from '@/router';
import { useSiderMenuItems } from '@/components/layouts/AppLayoutWrapper/components/AppLayoutSider/application/useSiderMenuItems';
import { ECommonSchemaItemKeys, ECommonSchemaItemType } from '@/components/layouts/AppLayoutWrapper/components/AppLayoutSider/domains/constants';
import { useFoldersStore } from '@/stores/folders';
import { TCommonSchemaItem } from '@/components/layouts/AppLayoutWrapper/components/AppLayoutSider/domains/types';
import { useTenantsStore } from '@/stores/tenants';
import { hasInstanceLicense } from '@/domains/hasInstanceLicense';

import { hasCargoOwnerWorkplaceSubscription, hasCarrierWorkplaceSubscription } from './permissions/subscription';
import isTenantVerified from './isTenantVerified';

/** Запрос на /info должен уходить до вызова функции redirectToInitialRoute.
 * Иначе появится "моргалка" либо бесконечный лоадер */
const redirectToInitialRoute = (route?: string | null) => {
  const foldersStore = useFoldersStore();
  const tenantsStore = useTenantsStore();

  const { siderMenuItems } = useSiderMenuItems(foldersStore);

  if (route) {
    return router.push(route);
  }

  const hasActiveSubscription = computed(() => !!tenantsStore.getActiveSubscription);
  const hasLicenseRole = !!tenantsStore.currentTenantDetails?.licenseRole;

  // редиректим на корневой роут, если:
  // на инстансе есть настройки лицензии, но не засечена роль тенанта
  // или нет настроек лицензии (используется биллинг), но тенант не верифицирован или не имеет активной подписки
  if ((hasInstanceLicense() && (!isTenantVerified() || !hasLicenseRole))
     || (!hasInstanceLicense() && (!isTenantVerified() || !hasActiveSubscription.value))) {
    return router.push('/');
  }

  let firstPage: string | null = null;
  if (hasCarrierWorkplaceSubscription()) { // если ГП, то firstPage всегда Лента заказов
    firstPage = siderMenuItems.value
      .filter((item: TCommonSchemaItem) => item.key === ECommonSchemaItemKeys.executorsLookupsFeed)[0]?.path || null;
  } else if (hasCargoOwnerWorkplaceSubscription()) { // если ГВ, то firstPage всегда Заказы
    firstPage = siderMenuItems.value
      .filter((item: TCommonSchemaItem) => item.key === ECommonSchemaItemKeys.orders)[0]?.path || null;
  } else {
    firstPage = siderMenuItems.value
      .filter((item: TCommonSchemaItem) => item.type !== ECommonSchemaItemType.withDivider)[0]?.path || null;
  }

  if (firstPage) {
    return router.push(firstPage);
  }

  return Promise.resolve();
};

export default redirectToInitialRoute;
